import React, { useEffect, useState } from "react";
import { getApprovedTestimonialsApi } from "../../api/testimonialService";

const ApprovedTestimonials = () => {
  const [testimonials, setTestimonials] = useState([]);

  const fetchTestimonials = async () => {
    try {
      const response = await getApprovedTestimonialsApi();
      setTestimonials(
        response.data.testimonials || response.testimonials || [],
      );
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchTestimonials();
  }, []);

  return (
    <div className="container-fluid p-4 np-testimonials-page">
      <h5>Approved Testimonials</h5>
      <div className="card p-3">
      <table className="table table-bordered table-hover align-middle">
        <thead className="table-light">
          <tr>
            <th className="fw-bold text-black">#</th>
            <th className="fw-bold text-black"> Product Name</th>
            <th className="fw-bold text-black">city And State</th>
            <th className="fw-bold text-black">Rating</th>
            <th className="fw-bold text-black">Status</th>
          </tr>
        </thead>

        <tbody>
          {testimonials.length > 0 ? (
            testimonials.map((item, index) => (
              <tr key={item._id}>
                <td>{index + 1}</td>
                <td>{item.name}</td>

                <td>
                  {item.city},{item.state}
                </td>
                <td>
                  {[1, 2, 3, 4, 5].map((star) => (
                    <span
                      key={star}
                      style={{
                        color: star <= item.rating ? "#ffc107" : "#d6d6d6",
                        fontSize: "18px",
                      }}
                    >
                      ★
                    </span>
                  ))}
                </td>
                <td>
                  <span className="badge bg-success">{item.status}</span>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center">
                No Approved Testimonials Found
              </td>
            </tr>
          )}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default ApprovedTestimonials;
